import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchingQualityAssuranceOrdersList = (params = {}, limit = 20, page = 0) => {
  const itemsCount = `&limit=${limit}`;
  const offset = `&offset=${page * limit}`;

  return apiActionCreator({
    'endpoint': `/quality-assurance/orders${getUrlParameters(params)}${itemsCount}${offset}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_QUALITY_ASSURANCE_ORDERS_LIST,
      ActionTypes.FETCHED_QUALITY_ASSURANCE_ORDERS_LIST,
      [
        ActionTypes.FETCHED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const closeQualityAssuranceOrder = (order, status) => {
  return apiActionCreator({
    'endpoint': `/quality-assurance/orders/${order}/${status}`,
    'authenticated': true,
    'types': [
      ActionTypes.CLOSING_QUALITY_ASSURANCE_ORDER,
      ActionTypes.CLOSED_QUALITY_ASSURANCE_ORDER,
      [
        ActionTypes.CLOSED_QUALITY_ASSURANCE_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
  });
};

export const setQualityAssuranceFilter = (newFilter) => ({
  'type': ActionTypes.SET_QA_ORDERS_FILTER,
  'payload': newFilter,
});

export const clearQualityAssuranceFilter = () => ({
  'type': ActionTypes.CLEAR_QA_ORDERS_FILTER,
});

export const downloadQualityAssuranceOrdersList = (params = {}) => {
  return apiActionCreator({
    'endpoint': `/quality-assurance/orders/export${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.EXPORTING_QUALITY_ASSURANCE_ORDERS_LIST,
      [
        (response) => {
          return {
            'type': ActionTypes.EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST,
            'payload': response.data,
          };
        },
      ],
      [
        ActionTypes.EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
